import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useCallback } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon } from '@skatteetaten/ds-icons';
import { v as valueRegex } from '../utils.esm.js';
import { TabsContext } from '../TabsContext/index.esm.js';
import './styles.css';


var styles = {
    "tab": "TabsTab-module_tab__kT3vB",
    "tab_active": "TabsTab-module_tab_active__hzE-L",
    "tab_compact": "TabsTab-module_tab_compact__htA--",
    "tab_border": "TabsTab-module_tab_border__jWrSd",
    "tab_icon": "TabsTab-module_tab_icon__M-XCx"
};

const TabsTab = /*#__PURE__*/ forwardRef(({ className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, svgPath, value, onClick, children }, ref)=>{
    const { activeTab, baseId, hasBorder, variant, setInternalActiveTab } = useContext(TabsContext);
    const tabClassName = styles.tab;
    const variantClassName = variant === 'compact' ? styles.tab_compact : '';
    const activeClassName = activeTab === value ? styles.tab_active : '';
    const borderClassName = hasBorder ? styles.tab_border : '';
    const withIconClassName = svgPath ? styles.tab_icon : '';
    if (!valueRegex.test(value)) {
        throw new Error('Value kan kun inneholde tegn som er gyldig i en html id.');
    }
    const handleKeyboardNavigation = useCallback((event)=>{
        switch(event.key){
            case 'ArrowRight':
                {
                    const next = event.currentTarget.nextSibling;
                    const current = event.currentTarget;
                    if (next) {
                        next.focus();
                    } else {
                        (current.parentElement?.firstChild).focus();
                    }
                    break;
                }
            case 'ArrowLeft':
                {
                    const previous = event.currentTarget.previousSibling;
                    const current = event.currentTarget;
                    if (previous) {
                        previous.focus();
                    } else {
                        (current.parentElement?.lastChild).focus();
                    }
                    break;
                }
            default:
                return;
        }
    }, []);
    return /*#__PURE__*/ jsxs("button", {
        ref: ref,
        id: `ds-tab-id-${baseId}-${value}`,
        className: `${tabClassName} ${variantClassName} ${borderClassName} ${activeClassName} ${withIconClassName} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        role: 'tab',
        tabIndex: activeTab !== value ? -1 : 0,
        "aria-selected": activeTab === value,
        "aria-controls": `ds-tab-panel-${baseId}-${value}`,
        onClick: ()=>{
            if (onClick) {
                onClick(value);
            } else {
                setInternalActiveTab(value);
            }
        },
        onKeyDown: (e)=>{
            handleKeyboardNavigation(e);
        },
        children: [
            svgPath && /*#__PURE__*/ jsx(Icon, {
                svgPath: svgPath,
                variant: 'systemIcon',
                size: 'small'
            }),
            children
        ]
    });
});
TabsTab.displayName = 'TabsTab';

export { TabsTab };
